import { get, writable } from 'svelte/store';

type Drawer = {
  id: string | null;
  cleanup?: () => void;
  meta?: Record<string, unknown>;
};

export const drawer = (() => {
  const store = writable<Drawer>({ id: null });

  const open = (id: string, drawer: Omit<Drawer, 'id'> = {}) => {
    store.update(() => ({ id, ...drawer }));
  };

  const close = () => {
    get(store).cleanup?.();
    store.update(() => ({ id: null }));
  };

  return {
    subscribe: store.subscribe,
    open,
    close
  };
})();
